var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25197 1.64499C9.97821 0.756245 11.2245 0.0737495 12.2907 0C12.4694 1.21499 11.9757 2.40498 11.3232 3.24623C10.6257 4.14997 9.42197 4.84872 8.25698 4.81247C8.04448 3.64873 8.58947 2.45123 9.25197 1.64499ZM12.6832 4.68122C14.0419 4.68122 15.4807 5.42621 16.5044 6.70995C13.1482 8.56119 13.6919 13.3837 17.0832 14.6749C16.6169 15.7149 16.3932 16.1786 15.7919 17.0999C14.9532 18.3849 13.7719 19.9861 12.3057 19.9974C11.703 20.0037 11.3076 19.8213 10.8812 19.6246C10.3871 19.3966 9.85137 19.1495 8.90322 19.1549C7.96028 19.1595 7.41601 19.4036 6.9151 19.6283C6.47775 19.8244 6.07346 20.0057 5.46574 19.9999C4.00075 19.9874 2.88076 18.5424 2.04202 17.2574C-0.301717 13.6662 -0.549215 9.44994 0.897025 7.20745C1.92577 5.61496 3.54826 4.68372 5.072 4.68372C5.8841 4.68372 6.53862 4.91839 7.16234 5.14203C7.73002 5.34557 8.2722 5.53996 8.88447 5.53996C9.45102 5.53996 9.91682 5.36249 10.4249 5.1689C11.0345 4.93666 11.7049 4.68122 12.6832 4.68122Z",
    fill: "#FCFAF9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.908c991b12ce34401c773462060f61b7.svg";
export { ForwardRef as ReactComponent };